import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';
import {Button, Typography, VerticalSpacer} from '../..';

const Styled = styled.div``;

export interface LicenseContactButtonProps {
    className?: string;
    accentColor?: AccentColorOptions;
    contactDescription?: string;
    contactButtonText?: string;
    onClick?: () => void;
}

export const LicenseContactButton = ({
    className,
    accentColor,
    contactDescription,
    contactButtonText,
    onClick
}: LicenseContactButtonProps): JSX.Element => {
    return (
        <Styled className={`${className || ''} License-contact-button`}>
            <VerticalSpacer variant="custom" downSmSpacing={5} />
            {contactDescription && (
                <Typography variant="p" accentColor={accentColor}>
                    {contactDescription}
                </Typography>
            )}
            {contactButtonText && onClick && (
                <>
                    <VerticalSpacer variant="eyebrow" />
                    <Button color={accentColor} onClick={onClick}>
                        {contactButtonText}
                    </Button>
                    <VerticalSpacer variant="custom" spacing={7} downSmSpacing={5} />
                </>
            )}
        </Styled>
    );
};
